import { RESET_STORE } from '../generalTypes'
// eslint-disable-next-line import/no-cycle
import { IVersionPayload, IIframeVersionPayload } from './versionActions'
// eslint-disable-next-line import/no-cycle
import { ILoadingAndFailure } from '../../types/interfaces'
import { IFRAME_VERSIONS, VERSIONS } from './versionTypes'

export const initState = {
	versions: {
		originalData: {},
		isLoading: false,
		isFailure: false
	} as IVersionPayload & ILoadingAndFailure,
	iframeVersions: {
		originalData: {},
		isLoading: false,
		isFailure: false
	} as IIframeVersionPayload & ILoadingAndFailure
}

export default (state = initState, action: any) => {
	switch (action.type) {
		// Versions
		case VERSIONS.VERSIONS_LOAD_START:
			return {
				...state,
				versions: {
					...state.versions,
					isFailure: false,
					isLoading: true
				}
			}
		case VERSIONS.VERSIONS_LOAD_FAIL:
			return {
				...state,
				versions: {
					...initState.versions,
					isFailure: true
				}
			}
		case VERSIONS.VERSIONS_LOAD_DONE:
			return {
				...state,
				versions: {
					...initState.versions,
					originalData: action.payload.originalData
				}
			}
		case IFRAME_VERSIONS.IFRAME_VERSIONS_LOAD_START:
			return {
				...state,
				iframeVersions: {
					...state.versions,
					isFailure: false,
					isLoading: true
				}
			}
		case IFRAME_VERSIONS.IFRAME_VERSIONS_LOAD_FAIL:
			return {
				...state,
				iframeVersions: {
					...initState.versions,
					isFailure: true
				}
			}
		case IFRAME_VERSIONS.IFRAME_VERSIONS_LOAD_DONE:
			return {
				...state,
				iframeVersions: {
					...initState.versions,
					originalData: action.payload.originalData
				}
			}
		case RESET_STORE:
			return initState
		default:
			return state
	}
}
